import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loadingContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
  },
  scrollView: {
    flex: 1,
  },
  feedBody: {
    flex: 1,
    position: 'relative',
    // Recorta o player do feed (FeedVideoOverlay, absoluto aqui dentro) na borda
    // superior — sem isto ele passaria por cima do cabeçalho ao rolar.
    overflow: 'hidden',
  },
  flashListContent: {
    paddingTop: 42,
    paddingBottom: 100,
  },
  emptyState: {
    padding: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyText: {
    fontSize: 16,
    textAlign: 'center',
  },
  // Header
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 50,
    paddingBottom: 12,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
  },
  headerLogo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  backBtn: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: 'rgba(255,255,255,0.1)',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
  backIcon: {
    fontSize: 18,
    color: '#FFFFFF',
  },
  logoText: {
    fontSize: 20,
    fontWeight: '700',
  },
  communityBadge: {
    backgroundColor: 'rgba(91, 143, 249, 0.15)',
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 10,
  },
  communityBadgeText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#5B8FF9',
  },
  headerActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  communityHeaderLayer: {
    zIndex: 10,
    elevation: 10,
  },
  communityHeaderRightAuth: {
    width: 144,
    alignItems: 'flex-end',
  },
  communityHeaderRightGuest: {
    width: 76,
    alignItems: 'flex-end',
  },
  enterButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: 'rgba(255,255,255,0.15)',
    borderRadius: 20,
  },
  enterButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  notificationBtn: {
    width: 36,
    height: 36,
    borderRadius: 18,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  notificationIcon: {
    fontSize: 16,
  },
  notificationBadge: {
    position: 'absolute',
    top: -2,
    right: -2,
    backgroundColor: '#FF6B6B',
    borderRadius: 8,
    minWidth: 16,
    height: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  notificationBadgeText: {
    fontSize: 9,
    fontWeight: '700',
    color: '#FFFFFF',
  },
  avatarBtn: {
    width: 36,
    height: 36,
    borderRadius: 18,
    borderWidth: 2,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(91, 143, 249, 0.1)',
  },
  avatarEmoji: {
    fontSize: 18,
  },
  profileButtonContainer: {
    padding: 2,
  },
  profileAreaRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  profileStatsCol: {
    alignItems: 'flex-end',
    marginRight: 6,
  },
  profileRankingBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.4)',
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 10,
    marginBottom: 2,
  },
  profileRankingIcon: {
    fontSize: 12,
    marginRight: 2,
  },
  profileRankingText: {
    fontSize: 11,
    fontWeight: '700',
    color: '#FFD700',
  },
  profileXpPill: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(139, 92, 246, 0.4)',
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 10,
  },
  profileXpIcon: {
    fontSize: 10,
    marginRight: 2,
  },
  profileXpText: {
    fontSize: 10,
    fontWeight: '700',
    color: '#E9D5FF',
  },
  profileAvatarImg: {
    width: 42,
    height: 42,
    borderRadius: 21,
    borderWidth: 2,
    borderColor: 'rgba(91, 143, 249, 0.5)',
  },
  // ═══════════════════════════════════════════════════════════════
  // VIDEO FEED SECTION - YouTube Style
  // ═══════════════════════════════════════════════════════════════
  videoFeedSection: {
    paddingTop: 20,
    paddingBottom: 8,
  },
  videoFeedTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#FFFFFF',
    paddingHorizontal: 16,
    marginBottom: 12,
  },
  videoFeedScrollContent: {
    paddingHorizontal: 16,
    gap: 12,
  },
  videoCard: {
    width: 280,
  },
  videoThumbnail: {
    width: '100%',
    height: 158,
    borderRadius: 12,
    overflow: 'hidden',
    position: 'relative',
  },
  videoThumbnailBg: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  videoThumbnailIcon: {
    fontSize: 40,
    marginBottom: 8,
  },
  videoThumbnailText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#FFFFFF',
    textAlign: 'center',
  },
  videoDuration: {
    position: 'absolute',
    bottom: 8,
    right: 8,
    backgroundColor: 'rgba(0,0,0,0.8)',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  videoDurationText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  videoInfo: {
    flexDirection: 'row',
    paddingTop: 10,
    gap: 8,
  },
  videoInfoText: {
    flex: 1,
  },
  videoTitle: {
    fontSize: 14,
    fontWeight: '500',
    color: '#FFFFFF',
    lineHeight: 18,
    marginBottom: 4,
  },
  videoChannel: {
    fontSize: 12,
    color: '#A0A3B1',
    marginBottom: 2,
  },
  videoMeta: {
    fontSize: 12,
    color: '#6B6E7B',
  },
  videoMenuBtn: {
    padding: 4,
  },
  videoMenuIcon: {
    fontSize: 16,
    color: '#A0A3B1',
  },
  // ═══════════════════════════════════════════════════════════════
  // SHORTS SECTION - YouTube Style
  // ═══════════════════════════════════════════════════════════════
  shortsSection: {
    paddingTop: 16,
    paddingBottom: 16,
  },
  shortsTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    marginBottom: 12,
    gap: 8,
  },
  shortsIcon: {
    width: 28,
    height: 28,
    borderRadius: 6,
    backgroundColor: '#FF0000',
    justifyContent: 'center',
    alignItems: 'center',
  },
  shortsIconText: {
    fontSize: 12,
    color: '#FFFFFF',
    fontWeight: '700',
  },
  shortsTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#FFFFFF',
  },
  shortsScrollContent: {
    paddingHorizontal: 16,
    gap: 10,
  },
  shortCard: {
    width: 160,
    height: 280,
    borderRadius: 12,
    overflow: 'hidden',
    position: 'relative',
  },
  shortThumbnail: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  shortThumbnailIcon: {
    fontSize: 50,
  },
  shortOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 12,
    paddingTop: 40,
    background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
  shortTitle: {
    fontSize: 13,
    fontWeight: '600',
    color: '#FFFFFF',
    marginBottom: 4,
  },
  shortViews: {
    fontSize: 11,
    color: 'rgba(255,255,255,0.7)',
  },
  // Search
  searchSection: {
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  searchContainer: {
    position: 'absolute',
    top: -13,
    left: 0,
    right: 0,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    height: 48,
    borderRadius: 18,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 1,
    zIndex: 4,
    elevation: 4,
    overflow: 'hidden',
  },
  searchContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  // Banner "Novos posts" (realtime) — pílula flutuante centrada no topo do feed.
  // backgroundColor vem inline (colors.accentPrimary) por causa do tema.
  newPostsBanner: {
    position: 'absolute',
    top: 12,
    alignSelf: 'center',
    zIndex: 20,
    elevation: 6,
    paddingHorizontal: 18,
    paddingVertical: 9,
    borderRadius: 20,
    shadowColor: '#000',
    shadowOpacity: 0.2,
    shadowRadius: 4,
    shadowOffset: { width: 0, height: 2 },
  },
  newPostsBannerText: {
    color: '#FFFFFF',
    fontSize: 13,
    fontWeight: '700',
  },
  // Card de post otimista (recém-criado, aguardando confirmação do servidor).
  optimisticPost: {
    opacity: 0.55,
  },
  searchIcon: {
    fontSize: 14,
    marginRight: 8,
    transform: [{ translateY: 4 }],
  },
  searchInput: {
    flex: 1,
    fontSize: 13,
    paddingVertical: 0,
    transform: [{ translateY: 4 }],
  },
  // Community Banner - Animated Gradient Style (same dimensions)
  communityBanner: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 16,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 12,
    marginBottom: 10,
    overflow: 'hidden',
  },
  bannerContentAnimated: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
  },
  bannerEmojiAnimated: {
    fontSize: 26,
  },
  bannerTextContainer: {
    alignItems: 'flex-start',
  },
  bannerTitleAnimated: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
    textAlign: 'left',
  },
  bannerHighlight: {
    color: '#FFD700',
    fontWeight: '700',
  },
  bannerIndicators: {
    flexDirection: 'row',
    gap: 6,
    marginTop: 8,
  },
  bannerDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: 'rgba(255,255,255,0.3)',
  },
  bannerDotActive: {
    backgroundColor: '#FFD700',
    width: 16,
  },
  // Topics Filter
  topicsContainer: {
    marginBottom: 12,
  },
  topicsContent: {
    paddingHorizontal: 16,
    gap: 8,
    flexDirection: 'row',
  },
  topicChip: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    // 12 em vez de 20: o chip tem ~32px de altura, entao 20 saturava no meio da
    // altura e virava pilula. 12 mantem o canto suave, mas com forma de tag.
    borderRadius: 12,
    borderWidth: 1,
    gap: 6,
  },
  topicChipIcon: {
    fontSize: 14,
  },
  topicChipText: {
    fontSize: 13,
    fontWeight: '500',
  },
  // Contributors Card
  contributorsCard: {
    marginHorizontal: 16,
    padding: 14,
    borderRadius: 12,
    borderWidth: 1,
    marginBottom: 16,
  },
  contributorsTitle: {
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 12,
  },
  contributorsList: {
    gap: 10,
  },
  contributorItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  contributorRank: {
    width: 22,
    height: 22,
    borderRadius: 11,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contributorRankText: {
    fontSize: 11,
    fontWeight: '700',
    color: '#FFFFFF',
  },
  contributorAvatar: {
    fontSize: 20,
  },
  contributorName: {
    flex: 1,
    fontSize: 13,
    fontWeight: '500',
  },
  contributorPoints: {
    fontSize: 12,
    fontWeight: '600',
  },
  // Feed Section
  feedSection: {
    paddingHorizontal: 16,
  },
  feedHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  feedTitle: {
    fontSize: 16,
    fontWeight: '700',
  },
  // Post Card
  postCard: {
    flexDirection: 'row',
    borderRadius: 12,
    borderWidth: 1,
    marginBottom: 12,
    overflow: 'hidden',
  },
  votingBar: {
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 8,
    gap: 4,
  },
  voteBtn: {
    padding: 6,
  },
  voteBtnIcon: {
    fontSize: 14,
  },
  voteCount: {
    fontSize: 13,
    fontWeight: '700',
    minWidth: 30,
    textAlign: 'center',
  },
  postContent: {
    flex: 1,
    padding: 12,
    gap: 8,
  },
  postHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  postMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 6,
  },
  topicBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 6,
    gap: 4,
  },
  topicBadgeIcon: {
    fontSize: 10,
  },
  topicBadgeText: {
    fontSize: 11,
    fontWeight: '600',
  },
  postSeparator: {
    fontSize: 10,
  },
  authorInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  authorAvatar: {
    fontSize: 14,
  },
  authorName: {
    fontSize: 11,
    fontWeight: '500',
  },
  postTime: {
    fontSize: 11,
  },
  solvedBadge: {
    backgroundColor: 'rgba(81, 207, 102, 0.15)',
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 6,
  },
  solvedBadgeText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#51CF66',
  },
  postTitle: {
    fontSize: 15,
    fontWeight: '700',
    lineHeight: 20,
  },
  postBody: {
    fontSize: 13,
    lineHeight: 18,
  },
  postMedia: {
    height: 120,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  postMediaPlaceholder: {
    fontSize: 24,
  },
  tagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  tag: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
  },
  tagText: {
    fontSize: 11,
  },
  postFooter: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 10,
    borderTopWidth: 1,
    gap: 12,
  },
  postAction: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 6,
  },
  postActionIcon: {
    fontSize: 14,
  },
  postActionText: {
    fontSize: 11,
    fontWeight: '500',
  },
  // Load More
  loadMoreBtn: {
    paddingVertical: 14,
    borderRadius: 12,
    borderWidth: 1,
    alignItems: 'center',
    marginTop: 4,
  },
  loadMoreText: {
    fontSize: 13,
    fontWeight: '600',
  },
  // FAB
  fab: {
    position: 'absolute',
    bottom: 24,
    right: 16,
    borderRadius: 25,
    overflow: 'hidden',
    shadowColor: '#5B8FF9',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.4,
    shadowRadius: 8,
    elevation: 8,
  },
  fabIcon: {
    fontSize: 16,
  },
  fabText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  bottomPadding: {
    height: 100,
  },
  // Modal de Detalhes do Post
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    justifyContent: 'flex-end',
  },
  // Folha do detalhe do post (deixou de ser <Modal> nativo — ver PostDetailModal).
  //
  // ⚠️ Ordem de empilhamento dentro do feedBody — mexer aqui quebra coisas:
  //   busca 4  <  banner "Novos posts" 20  <  FOLHA 22  <  player 25
  // A folha precisa ficar ACIMA da busca e do banner (senão a chrome do feed
  // flutua sobre o post aberto — era assim antes, e o <Modal> nativo escondia o
  // problema por ser outra janela) e ABAIXO do player (que é o que permite o
  // vídeo continuar tocando por cima dela, sem remontar).
  sheetRoot: {
    zIndex: 22,
    elevation: 8,
  },
  // O escurecimento é uma camada própria porque só ele deve animar opacidade;
  // a folha em si entra por translateY.
  sheetBackdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
  sheetLayout: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  // Espaço reservado do player externo, fixo abaixo do cabeçalho da folha.
  externalPlayerSlot: {
    width: '100%',
    aspectRatio: 16 / 9,
    backgroundColor: '#000000',
  },
  modalBackdrop: {
    flex: 1,
    width: '100%',
  },
  modalContainer: {
    height: '90%',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    overflow: 'hidden',
  },
  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 4,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
  },
  modalCloseBtn: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: 'rgba(255,255,255,0.1)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalCloseBtnText: {
    fontSize: 14,
    color: '#FFFFFF',
  },
  modalTitle: {
    fontSize: 15,
    fontWeight: '700',
  },
  modalContent: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  postModalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  postModalTopicBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 12,
  },
  postModalTopicIcon: {
    fontSize: 14,
    marginRight: 6,
  },
  postModalTopicText: {
    fontSize: 13,
    fontWeight: '600',
  },
  postModalTime: {
    fontSize: 12,
  },
  postModalAuthorRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    gap: 8,
  },
  postModalAuthorAvatar: {
    fontSize: 24,
  },
  postModalAuthorName: {
    fontSize: 15,
  },
  postModalSolvedBadge: {
    backgroundColor: 'rgba(81, 207, 102, 0.2)',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
  },
  postModalSolvedText: {
    fontSize: 11,
    fontWeight: '600',
    color: '#51CF66',
  },
  postModalPostTitle: {
    fontSize: 20,
    fontWeight: '700',
    marginBottom: 12,
    lineHeight: 26,
  },
  postModalPostBody: {
    fontSize: 16,
    lineHeight: 24,
    marginBottom: 16,
  },
  postModalTagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 16,
  },
  postModalTag: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 12,
  },
  postModalTagText: {
    fontSize: 13,
  },
  postModalStatsBar: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    borderTopWidth: 1,
    marginBottom: 20,
  },
  postModalVoteSection: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  postModalVoteBtn: {
    padding: 8,
  },
  postModalVoteIcon: {
    fontSize: 18,
  },
  postModalVoteCount: {
    fontSize: 16,
    fontWeight: '700',
  },
  postModalCommentCount: {
    fontSize: 14,
  },
  postModalCommentsSection: {
    marginTop: 8,
  },
  postModalCommentsTitle: {
    fontSize: 17,
    fontWeight: '700',
    marginBottom: 16,
  },
  postModalCommentCard: {
    padding: 14,
    borderRadius: 12,
    borderWidth: 1,
    marginBottom: 12,
  },
  postModalCommentHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  postModalCommentAuthor: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  postModalCommentAvatar: {
    fontSize: 18,
  },
  postModalCommentAuthorName: {
    fontSize: 14,
    fontWeight: '600',
  },
  postModalCommentTime: {
    fontSize: 12,
  },
  postModalCommentContent: {
    fontSize: 14,
    lineHeight: 20,
  },
  postModalCommentInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    borderTopWidth: 1,
    gap: 10,
  },
  postModalCommentInput: {
    flex: 1,
    borderWidth: 1,
    borderRadius: 20,
    paddingHorizontal: 16,
    paddingVertical: 10,
    fontSize: 14,
    maxHeight: 100,
  },
  postModalSendBtn: {
    width: 44,
    height: 44,
    borderRadius: 22,
    justifyContent: 'center',
    alignItems: 'center',
  },
  postModalSendBtnText: {
    fontSize: 18,
    color: '#FFFFFF',
  },
  // Estilos Discord para comentários
  discordComment: {
    flexDirection: 'row',
    paddingVertical: 8,
    paddingHorizontal: 4,
  },
  discordAvatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  discordAvatarImg: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginRight: 12,
  },
  discordAvatarEmoji: {
    fontSize: 20,
  },
  discordCommentContent: {
    flex: 1,
  },
  discordCommentHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 4,
  },
  discordAuthorName: {
    fontSize: 15,
    fontWeight: '600',
  },
  discordTime: {
    fontSize: 12,
  },
  discordMessage: {
    fontSize: 15,
    lineHeight: 22,
  },
  // Divisor entre comentários de usuários diferentes
  discordDivider: {
    height: 1,
    marginVertical: 12,
    marginLeft: 52,
    opacity: 0.5,
  },
  // Indicador de reply
  discordReplyIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
    paddingLeft: 2,
  },
  discordReplyLine: {
    width: 2,
    height: 16,
    borderRadius: 1,
    marginRight: 8,
  },
  discordReplyText: {
    fontSize: 12,
    flex: 1,
  },
  // Divisor com data entre comentários principais
  dateDividerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 20,
    paddingHorizontal: 4,
  },
  dateDividerLine: {
    flex: 1,
    height: 1,
    opacity: 0.4,
  },
  dateDividerText: {
    fontSize: 12,
    fontWeight: '500',
    paddingHorizontal: 12,
  },
  // Mantido para compatibilidade
  mainCommentDivider: {
    height: 1,
    marginVertical: 16,
    opacity: 0.4,
  },
  // Threading - Container
  threadContainer: {
    position: 'relative',
  },
  repliesContainer: {
    marginTop: 4,
  },
  // Threading - Linhas de conexão
  threadLineVertical: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: 2,
    borderRadius: 1,
  },
  threadLineHorizontal: {
    position: 'absolute',
    left: 0,
    top: 24,
    width: 16,
    height: 2,
    borderRadius: 1,
  },
  // Comentário com threading (resposta)
  threadedComment: {
    marginLeft: 20,
    paddingVertical: 6,
  },
  threadedAvatar: {
    width: 32,
    height: 32,
    borderRadius: 16,
  },
  threadedAvatarImg: {
    width: 32,
    height: 32,
    borderRadius: 16,
    marginRight: 10,
  },
  // Botão de responder
  replyButton: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    padding: 4,
  },
  replyIcon: {
    fontSize: 14,
  },
  // Indicador de "Respondendo a @user"
  replyingToIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderBottomWidth: 1,
  },
  replyingToContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  replyingToLabel: {
    fontSize: 13,
  },
  replyingToAuthor: {
    fontSize: 13,
    fontWeight: '600',
  },
  replyingToClose: {
    padding: 4,
  },
  replyingToCloseIcon: {
    fontSize: 16,
    fontWeight: '600',
  },
  // FAB (Floating Action Button)
  fabContainer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    alignItems: 'center',
  },
  fabButton: {
    width: 48,
    height: 48,
    borderRadius: 24,
    // Halo da sombra acompanha a cor do botao (era o roxo #7C3AED).
    shadowColor: '#03386C',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.4,
    shadowRadius: 8,
    elevation: 8,
  },
  fabGradient: {
    width: 48,
    height: 48,
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  fabPlusIcon: {
    fontSize: 26,
    fontWeight: '300',
    color: '#FFFFFF',
    marginTop: -2,
  },
});
